export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/workspace/Nate/parcel-site/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/workspace/Nate/parcel-site/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: 'dashboard',
        name: '/admin/dashboard',
        component: () => import('/workspace/Nate/parcel-site/src/pages/admin/dashboard.vue'),
        /* no children */
        meta: {
          "layout": "admin"
        }
      },
      {
        path: 'login',
        name: '/admin/login',
        component: () => import('/workspace/Nate/parcel-site/src/pages/admin/login.vue'),
        /* no children */
        meta: {
          "layout": "auth"
        }
      },
      {
        path: 'reports',
        /* internal name: '/admin/reports' */
        /* no component */
        children: [
          {
            path: 'brandfetch',
            name: '/admin/reports/brandfetch',
            component: () => import('/workspace/Nate/parcel-site/src/pages/admin/reports/brandfetch.vue'),
            /* no children */
            meta: {
              "layout": "admin"
            }
          },
          {
            path: 'brandfetch-metrics',
            name: '/admin/reports/brandfetch-metrics',
            component: () => import('/workspace/Nate/parcel-site/src/pages/admin/reports/brandfetch-metrics.vue'),
            /* no children */
            meta: {
              "layout": "admin"
            }
          },
          {
            path: 'items',
            name: '/admin/reports/items',
            component: () => import('/workspace/Nate/parcel-site/src/pages/admin/reports/items.vue'),
            /* no children */
            meta: {
              "layout": "admin"
            }
          },
          {
            path: 'notification-integrity',
            name: '/admin/reports/notification-integrity',
            component: () => import('/workspace/Nate/parcel-site/src/pages/admin/reports/notification-integrity.vue'),
            /* no children */
            meta: {
              "layout": "admin"
            }
          },
          {
            path: 'notifications',
            name: '/admin/reports/notifications',
            component: () => import('/workspace/Nate/parcel-site/src/pages/admin/reports/notifications.vue'),
            /* no children */
            meta: {
              "layout": "admin"
            }
          },
          {
            path: 'platforms',
            name: '/admin/reports/platforms',
            component: () => import('/workspace/Nate/parcel-site/src/pages/admin/reports/platforms.vue'),
            /* no children */
            meta: {
              "layout": "admin"
            }
          },
          {
            path: 'series-carriers',
            name: '/admin/reports/series-carriers',
            component: () => import('/workspace/Nate/parcel-site/src/pages/admin/reports/series-carriers.vue'),
            /* no children */
            meta: {
              "layout": "admin"
            }
          },
          {
            path: 'series-platforms',
            name: '/admin/reports/series-platforms',
            component: () => import('/workspace/Nate/parcel-site/src/pages/admin/reports/series-platforms.vue'),
            /* no children */
            meta: {
              "layout": "admin"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/carriers',
    name: '/carriers',
    component: () => import('/workspace/Nate/parcel-site/src/pages/carriers.vue'),
    /* no children */
  },
  {
    path: '/code',
    name: '/code',
    component: () => import('/workspace/Nate/parcel-site/src/pages/code.vue'),
    /* no children */
  },
  {
    path: '/devices',
    name: '/devices',
    component: () => import('/workspace/Nate/parcel-site/src/pages/devices.vue'),
    /* no children */
  },
  {
    path: '/faq',
    name: '/faq',
    component: () => import('/workspace/Nate/parcel-site/src/pages/faq.vue'),
    /* no children */
  },
  {
    path: '/loadlinks',
    name: '/loadlinks',
    component: () => import('/workspace/Nate/parcel-site/src/pages/loadlinks.vue'),
    /* no children */
  },
  {
    path: '/paymentlinks',
    name: '/paymentlinks',
    component: () => import('/workspace/Nate/parcel-site/src/pages/paymentlinks.vue'),
    /* no children */
  },
  {
    path: '/privacy',
    name: '/privacy',
    component: () => import('/workspace/Nate/parcel-site/src/pages/privacy.vue'),
    /* no children */
  },
  {
    path: '/shipping-guide',
    name: '/shipping-guide',
    component: () => import('/workspace/Nate/parcel-site/src/pages/shipping-guide.vue'),
    /* no children */
  },
  {
    path: '/terms',
    name: '/terms',
    component: () => import('/workspace/Nate/parcel-site/src/pages/terms.vue'),
    /* no children */
  },
  {
    path: '/unlock',
    name: '/unlock',
    component: () => import('/workspace/Nate/parcel-site/src/pages/unlock.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

